import { Badge } from '@art-of-hospitality-solutions-llc/ui-kit/components/badge';
import type { FlowStageStatus } from '../types';
import { cn } from '@Utils/cn';

const STATUS_CONFIG: Record<
  FlowStageStatus,
  { label: string; variant: 'default' | 'outline' }
> = {
  active: { label: 'Active stage', variant: 'default' },
  previous: { label: 'Previous stage', variant: 'outline' },
  next: { label: 'Next stage', variant: 'outline' },
  upcoming: { label: 'Upcoming stage', variant: 'outline' },
};

export interface StageStatusBadgeProps {
  status: FlowStageStatus;
  className?: string;
}

export function StageStatusBadge({
  status = 'previous',
  className,
}: StageStatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  return (
    <Badge
      variant={config.variant}
      className={cn(
        status !== 'active' && 'dark:bg-secondary bg-white',
        className,
      )}
    >
      {config.label}
    </Badge>
  );
}
